module.exports = __webpack_public_path__ + "img/64_9.ad37e5d5.png";